import TiptapUl from '@tiptap/extension-bullet-list';
import {wrappingInputRule} from '@tiptap/core';

export const inputRegex = /^\s*([-*])\s$/;

const TextStyleName = 'textStyle';

import appStyles from '../app-post-style.module.css';

export const TimeWebkitBulletListExtension = TiptapUl
    .extend({
        addInputRules() {
            let inputRule = wrappingInputRule({
                find: inputRegex,
                type: this.type,
            });

            if (this.options.keepMarks || this.options.keepAttributes) {
                inputRule = wrappingInputRule({
                    find: inputRegex,
                    type: this.type,
                    keepMarks: this.options.keepMarks,
                    keepAttributes: this.options.keepAttributes,
                    getAttributes: () => {
                        return this.editor.getAttributes(TextStyleName);
                    },
                    editor: this.editor,
                });
            }
            return [
                inputRule,
            ];
        },
    })
    .configure({
        HTMLAttributes: {
            class: appStyles.list,
        },
    });
